export default "__VITE_ASSET__2be658fa__"